module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAbCAYAAACTHcTmAAAAAXNSR0IArs4c6QAAAJhJREFUSEvtlbENwjAQRd8XLJQZqJHSsgQThCFYgiZFBDNQMgx9io9IBVaIEsd05/JkP/t8/9/J9g3YU261su1yvIH0/IQ2wH3FBTvglEJrSddcqO0DcAnoV6HiT0NSmZYKR0VDmdFPbW+AR6oySVUamy0p21ugH4FqDfR9+DgCPWdDl5jrV/p/maZLHja1dxgnHVCXIgLtC3ju/XZ3Xt2UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 1